export default 1;



// WEBPACK FOOTER //
// ./src/jsVersion.js